var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShyLogoQuotePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 36,
    viewBox: "0 0 209 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.115 11.124C18.7272 11.124 17.7552 15.2928 17.7552 15.2928V27.351L0 35.1486L20.034 0L40.3866 35.2782L22.4586 27.3672V15.309C22.4586 15.309 21.4866 11.1402 20.0988 11.1402",
    fill: "#D4BC87"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M80.6436 8.79102L72.9702 26.449H74.7144L81.5994 10.4542H82.08L86.2758 20.1958H78.9858L78.3324 21.7078H86.9238L88.965 26.449H90.7092L83.0358 8.79102H80.6436Z",
    fill: "#D4BC87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M101.228 24.7858H100.623L94.111 8.79102H92.3452L99.6406 26.449H102.211L109.479 8.79102H107.762L101.228 24.7858Z",
    fill: "#D4BC87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M116.035 8.79102H114.448V26.449H116.035V8.79102Z",
    fill: "#D4BC87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M128.396 8.79102L120.728 26.449H122.467L129.357 10.4542H129.838L134.028 20.1958H126.738L126.09 21.7078H134.682L136.723 26.449H138.462L130.794 8.79102H128.396Z",
    fill: "#D4BC87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M139.849 10.303H146.74V26.449H148.327V10.303H155.239V8.79102H139.849V10.303Z",
    fill: "#D4BC87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M162.178 8.79102H160.591V26.449H162.178V8.79102Z",
    fill: "#D4BC87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M182.147 9.67648C180.727 8.92048 179.156 8.54248 177.444 8.54248C175.732 8.54248 174.204 8.92048 172.778 9.67648C171.347 10.4325 170.219 11.5071 169.387 12.8949C168.555 14.2827 168.14 15.8595 168.14 17.6253C168.14 19.3911 168.555 20.9679 169.387 22.3557C170.219 23.7435 171.353 24.8127 172.778 25.5741C174.209 26.3301 175.764 26.7081 177.444 26.7081C179.123 26.7081 180.727 26.3301 182.147 25.5741C183.567 24.8181 184.701 23.7435 185.538 22.3557C186.381 20.9679 186.802 19.3911 186.802 17.6253C186.802 15.8595 186.381 14.2827 185.538 12.8949C184.696 11.5071 183.567 10.4379 182.147 9.67648ZM184.14 21.5727C183.443 22.7229 182.509 23.6139 181.337 24.2457C180.171 24.8775 178.869 25.1907 177.438 25.1907C176.007 25.1907 174.733 24.8775 173.556 24.2457C172.379 23.6139 171.444 22.7229 170.753 21.5727C170.062 20.4225 169.716 19.1049 169.716 17.6253C169.716 16.1457 170.062 14.8281 170.753 13.6779C171.444 12.5277 172.379 11.6367 173.556 11.0049C174.733 10.3731 176.029 10.0599 177.438 10.0599C178.848 10.0599 180.165 10.3731 181.337 11.0049C182.504 11.6367 183.438 12.5277 184.14 13.6779C184.836 14.8281 185.187 16.1457 185.187 17.6253C185.187 19.1049 184.836 20.4225 184.14 21.5727Z",
    fill: "#D4BC87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M206.453 8.79102V24.6616H205.869L195.555 8.79102H192.78V26.449H194.367V10.5838H194.951L205.265 26.449H208.04V8.79102H206.453Z",
    fill: "#D4BC87"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M50.4412 19.5965C49.7176 19.5965 49.1182 19.4507 48.6322 19.1537C48.1516 18.8567 47.7898 18.4679 47.5468 17.9765C47.3092 17.4905 47.1904 16.9451 47.1904 16.3457H48.3352C48.3352 16.7507 48.4108 17.1179 48.5566 17.4473C48.7024 17.7767 48.9346 18.0359 49.2532 18.2303C49.5664 18.4301 49.966 18.5273 50.4412 18.5273C51.0946 18.5273 51.586 18.3599 51.9208 18.0251C52.2556 17.6903 52.423 17.2853 52.423 16.8209C52.423 16.3565 52.3042 15.9569 52.072 15.6329C51.8398 15.3089 51.4726 15.0497 50.9758 14.8553L49.4962 14.2937C49.0102 14.0993 48.6106 13.8779 48.2974 13.6241C47.9842 13.3703 47.7574 13.0571 47.6008 12.6953C47.4496 12.3281 47.374 11.8907 47.374 11.3831C47.374 10.9025 47.4982 10.4597 47.7466 10.0493C47.995 9.6389 48.3514 9.30411 48.805 9.05571C49.264 8.80731 49.7932 8.68311 50.3926 8.68311C51.0352 8.68311 51.5914 8.8235 52.0612 9.1097C52.531 9.3959 52.8928 9.7847 53.1358 10.2761C53.3788 10.7675 53.503 11.3237 53.503 11.9339H52.3582C52.3582 11.5397 52.2826 11.1725 52.1314 10.8431C51.9802 10.5137 51.7534 10.2491 51.4618 10.0493C51.1648 9.8495 50.8084 9.7523 50.3926 9.7523C49.8256 9.7523 49.3666 9.9143 49.0264 10.2383C48.6862 10.5623 48.5134 10.9457 48.5134 11.3831C48.5134 11.8637 48.6214 12.2471 48.8428 12.5441C49.0642 12.8411 49.4098 13.0787 49.8904 13.2623L51.1702 13.7483C51.7318 13.9643 52.1854 14.2073 52.5364 14.4827C52.8874 14.7581 53.1466 15.0875 53.314 15.4655C53.4814 15.8435 53.5678 16.3025 53.5678 16.8317C53.5678 17.3609 53.4436 17.8037 53.2006 18.2303C52.9576 18.6569 52.6012 18.9863 52.1314 19.2347C51.6616 19.4831 51.1 19.6073 50.4358 19.6073L50.4412 19.5965Z",
    fill: "#D4BC87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M55.7061 19.4722V8.79102H56.8509V13.5538H61.2789V8.79102H62.4237V19.4722H61.2789V14.6176H56.8509V19.4722H55.7061Z",
    fill: "#D4BC87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M66.949 19.4722V15.5788L63.79 8.78564H65.0428L67.408 13.975H67.6348L70 8.78564H71.2528L68.0938 15.5788V19.4722H66.949Z",
    fill: "#D4BC87"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShyLogoQuotePdf);
export default __webpack_public_path__ + "static/media/shy-logo-quote-pdf.fac01139439f9e74a87255a9146319f3.svg";
export { ForwardRef as ReactComponent };